export const trendConfig = {
  Decreasing: {
    color: "#15b471",
    icon: "fa-solid fa-arrow-trend-down",
    name: "Decreasing",
  },
  Increasing: {
    color: "#ff4500",
    icon: "fa-solid fa-arrow-trend-up",
    name: "Increasing",
  },
  "No Change": {
    color: "#808080",
    icon: "fa-solid fa-minus",
    name: "No Change",
  },
  default: {
    color: "#808080",
    icon: "fa-solid fa-minus",
    name: "Unknown",
  },
};
